import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Flex, Box} from 'reflexbox';
import {inject, observer} from 'mobx-react';

// import {style} from "variables/Variables.jsx";
import {FormGroup, ControlLabel, FormControl, Row} from 'react-bootstrap';
import {Card, CardTitle, CardText, Slider} from 'react-md';
import Footer from "../../component/Footer";

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

@inject('MemberStore')
@observer
@withRouter
export class OnlineCertificatePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            found: false
        };
        this.positionImg = {
            MB: require('assets/img/bagdes/cci_mb.png'),
            DIS: require('assets/img/bagdes/cci_dis.png'),
            PRO: require('assets/img/bagdes/cci_pro.png'),
            VIP: require('assets/img/bagdes/cci_vip.png'),
        };

        this.honorImg = {
            PE: require('assets/img/bagdes/Platinum.jpg'),
            SE: require('assets/img/bagdes/Sapphire.jpg'),
            EE: require('assets/img/bagdes/Emerald.jpg'),
            DE: require('assets/img/bagdes/Diamond.png'),
            CE: require('assets/img/bagdes/Crown.png'),
        };

    }

    componentDidMount() {
        this.props.MemberStore.getCert(getParameterByName('code')).then(x => {
            console.log('Get member');
            this.setState({found: x});
        })

    }

    renderMember() {
        window.matchMedia("(min-width: 700px)");
        if (this.state.found) {
            var picUrl;
            const {member} = this.props.MemberStore;
            if (member.honor) {
                picUrl = this.honorImg[member.honor];
            } else {
                picUrl = this.positionImg[member.level];
            }

            return (
                <Flex className="member-cert-info">
                    <Flex className="member-pos" w={4/10} justify="center">
                        <img src={picUrl}/>
                    </Flex>
                    <Flex w={6/10}>
                        <Flex column justify="center">
                            <div><h3>ชื่อ : {member.full_name}</h3></div>
                            <div><h4>รหัสสมาชิก : {member.code}</h4></div>
                        </Flex>

                    </Flex>
                </Flex>
            )
        }
        else {
            return (
                <p>ไม่พบข้อมูล การผ่านอบรม</p>
            )
        }
    }

    render() {
        return (
            <div className="wrapper">
                <div id="cert-page">
                    <Card className="cert-card md-block-centered">
                        <CardTitle title="ใบอนุญาตขายออนไลน์"/>
                        <CardText>
                            <Flex column>
                                {this.renderMember()}
                                <Flex justify="center">
                                    <p style={{marginTop: 15}}>ได้ผ่านการฝึกอบรมกับทางบริษัทเป็นที่เรียบร้อยแล้ว</p>
                                </Flex>
                            </Flex>
                        </CardText>
                    </Card>
                </div>
                <footer className="footer-cert" >
                    <Flex>
                        <p className="copyright pull-right">
                            &copy; {(new Date()).getFullYear()} Champ of Champ Innovation
                        </p>
                    </Flex>
                </footer>
            </div>

        );
    }
}

export default OnlineCertificatePage;



// WEBPACK FOOTER //
// ./src/views/OnlineCertificate/OnlineCertificate.jsx